// extracted by mini-css-extract-plugin
export default {"root":"CXindH","mainSection":"IsgLzN","image":"PNmsRQ","button":"tfH4sv","buttonFont":"OYgPz5","ribbon":"hfD9rf"};